import { createReducer, on } from '@ngrx/store';
import { ColorMode } from '../../models/color-mode.model';
import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
} from '../../models/language.types';
import { AuthActions } from '../auth/auth.actions';
import { ColorModeActions, UiActions } from './ui.actions';

export interface UiState {
  readonly currentLanguage: SupportedLanguage;
  readonly isGlobalLoading: boolean;
  readonly sidenavOpen: boolean;
  readonly colorMode: ColorMode;
}

const DEFAULT_COLOR_MODE: ColorMode = 'light';

const getInitialLanguage = (): SupportedLanguage => {
  const storedLanguage = localStorage.getItem('preferred_language');
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(storedLanguage ?? '')
    ? (storedLanguage as SupportedLanguage)
    : DEFAULT_LANGUAGE;
};

export const initialUiState: UiState = {
  currentLanguage: getInitialLanguage(),
  isGlobalLoading: false,
  sidenavOpen: true,
  colorMode: DEFAULT_COLOR_MODE,
};

export const uiReducer = createReducer(
  initialUiState,
  on(ColorModeActions.loadRequested, (state) => ({
    ...state,
    colorMode: DEFAULT_COLOR_MODE,
  })),
  on(ColorModeActions.loadSucceeded, (state) => ({
    ...state,
    colorMode: DEFAULT_COLOR_MODE,
  })),
  on(ColorModeActions.selected, (state) => ({
    ...state,
    colorMode: DEFAULT_COLOR_MODE,
  })),
  on(AuthActions.logoutRequested, (state) => ({
    ...state,
    colorMode: DEFAULT_COLOR_MODE,
  })),
  on(UiActions.languageSelected, (state, { language }) => ({
    ...state,
    currentLanguage: language,
  })),
  on(UiActions.globalLoadingActivated, (state, { isLoading }) => ({
    ...state,
    isGlobalLoading: isLoading,
  })),
  on(UiActions.sidenavToggled, (state) => ({
    ...state,
    sidenavOpen: !state.sidenavOpen,
  })),
  on(UiActions.sidenavSet, (state, { open }) => ({
    ...state,
    sidenavOpen: open,
  })),
);
